export default "__VITE_ASSET__DO$vWRBz__"